package or.garden.manager.domain.model

import kotlinx.serialization.Serializable
import or.garden.manager.util.formatTimestampToHuman

@Serializable
data class NoteData(
    val id: Int,
    val title: String,
    val content: String,
    val createdAt: String
) {
    fun date() = formatTimestampToHuman(createdAt)
}
